
import { FORMATTING_INSTRUCTIONS } from './formattingInstructions';

// How to Win stage templates

export const howToWinTemplates = {
  howToWinTheory: `${FORMATTING_INSTRUCTIONS}

Objective: Develop comprehensive theory of change with multiple pathways and contingency planning for {campaign_name} campaign.

You are a senior political strategist and campaign director. Synthesize previous analysis into a unified theory of change with strategic pathways and implementation guidance.

Campaign Context:
- Issue: {political_issue}
- Target: {target_entity}
- Campaign Type: {campaign_type}
- Winning Aspiration: {winning_aspiration}
- Timeline: {campaign_timeline}

Strategic Context:
- Theory of Change: {theory_of_change}
- Required Capabilities: {required_capabilities}

Previous Analysis Context:
{previous_analysis}

Theory of Change Development Tasks:

1. STRATEGIC PATHWAY ANALYSIS:
Develop multiple pathways to victory:

PRIMARY PATHWAY - Direct Political Pressure:
- Key decision makers to influence and sequence of engagement
- Coalition building and stakeholder mobilization strategy
- Public pressure campaigns and accountability mechanisms
- Media strategy to amplify political pressure
- Timeline and escalation sequence for maximum impact

SECONDARY PATHWAY - Legislative/Regulatory Process:
- Formal procedural requirements and deadlines
- Committee processes and key decision points
- Amendment and modification opportunities
- Legislative calendar considerations and timing
- Alternative venues if primary process fails

TERTIARY PATHWAY - Public Opinion and Electoral Pressure:
- Public education and awareness building strategy
- Electoral consequences for decision makers
- Grassroots mobilization and constituency pressure
- Coalition expansion to maximize political cost of opposition
- Long-term electoral accountability mechanisms

2. CAPABILITY REQUIREMENTS ANALYSIS:
Map required organizational capabilities to strategic pathways:

Research and Intelligence Capabilities:
- Opposition tracking and rapid response research
- Policy analysis and technical expertise
- Media monitoring and message effectiveness tracking
- Stakeholder relationship mapping and maintenance

Communication and Messaging Capabilities:
- Message development and testing infrastructure
- Multi-channel communication coordination
- Rapid response and crisis communication
- Community-specific messaging and outreach

Political and Coalition Capabilities:
- Relationship building and maintenance with key stakeholders
- Coalition coordination and management
- Political negotiation and compromise strategy
- Grassroots organizing and mobilization

3. CONTINGENCY PLANNING:
Develop responses to likely scenarios and setbacks:

If Primary Decision Makers Remain Resistant:
- Escalation strategies to increase political pressure
- Alternative decision makers and venues
- Coalition expansion to broaden pressure base
- Timeline extension and sustained pressure planning

If Opposition Mobilizes Effectively:
- Counter-messaging and narrative warfare strategies
- Coalition defense and unity maintenance
- Alternative framing and issue repositioning
- Legal and procedural defense preparations

If External Events Disrupt Campaign:
- Crisis communication and message adaptation
- Timeline flexibility and strategic pivoting
- Resource reallocation and priority adjustment
- Opportunity identification in crisis situations

4. SUCCESS METRICS AND MILESTONE TRACKING:
Establish measurement framework for progress assessment:

Leading Indicators:
- Stakeholder engagement levels and quality
- Media coverage tone and frequency
- Opposition activity and resource expenditure
- Coalition growth and unity maintenance

Milestone Markers:
- Key stakeholder commitment and support levels
- Procedural progress through decision-making process
- Public opinion shifts and awareness growth
- Resource mobilization and organizational capacity

Victory Conditions:
- Specific decision maker commitments required
- Policy or procedural changes needed for success
- Coalition sustainability for long-term implementation
- Opposition neutralization or conversion metrics

5. RISK ASSESSMENT AND MITIGATION:
Identify and prepare for major campaign risks:

Political Risks:
- Changes in political leadership or priorities
- Opposition counter-mobilization and escalation
- External political events disrupting campaign focus
- Coalition fragmentation or defection

Organizational Risks:
- Resource shortfalls and sustainability challenges
- Leadership conflicts or strategic disagreements
- Communication failures and message discipline
- Legal or ethical challenges to campaign activities

Strategic Risks:
- Misreading political dynamics and timing
- Overestimating stakeholder support or commitment
- Underestimating opposition resources or determination
- Timeline miscalculation and opportunity windows

6. IMPLEMENTATION COORDINATION:
Develop organizational structure for strategy execution:

Decision-Making Structure:
- Campaign leadership roles and authority
- Strategic decision processes and consultation
- Rapid response decision authority
- Coalition coordination and communication

Resource Allocation Framework:
- Budget priorities and resource allocation criteria
- Personnel deployment and skill matching
- Timeline resource planning and contingency reserves
- Coalition resource sharing and coordination

Communication and Coordination:
- Internal communication systems and protocols
- External communication authority and discipline
- Coalition communication and information sharing
- Crisis communication and rapid response procedures

Provide comprehensive theory of change with detailed implementation guidance and contingency planning.
`
};
